import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Today's Live Chandi Ka Rate in Delhi — 1 Tola & 10 Gram Silver Price";
const DESC = "Live silver / chandi rate in Delhi today — per tola, per 10 gram, per gram & per kg. Hourly auto-update from international XAG spot + USD/INR FX.";

export const Route = createFileRoute("/chandi-ka-rate-delhi")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/chandi-ka-rate-delhi" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="india"
      cityName="Delhi"
      title="Today's Live Chandi (Silver) Rate in Delhi"
      intro="Live silver rate in Delhi — recalculated every 10 minutes from international XAG spot price and today's USD/INR rate. Per tola, per 10 gram, per gram and per kilogram."
    />
  ),
});
